module.exports = __webpack_public_path__ + "img/piaget-altiplano-ultimate-910p-4.836a418c.png";